module.exports = __webpack_public_path__ + "static/media/snake.447dcb14.webm";


//////////////////
// WEBPACK FOOTER
// ./src/Videos/snake.webm
// module id = 59
// module chunks = 0